import { Component, ViewChild, ElementRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { getDateAsUTC } from 'src/app/core';
import { CommonService } from 'src/app/core/common.service';

@Component({
  selector: 'date-field',
  template: `
<div class="input-group input-group-sm date-picker-custom">
  <input type="text"
         [formControl]="formControl"
         [placeholder]="props.placeholder || 'DD-MMM-YY'"
         class="form-control calendar"
         [formlyAttributes]="field"
         [class.is-invalid]="showError"
         [class.readonly-date]="true"
         [bsConfig]="bsConfig"
         bsDatepicker
         (bsValueChange)="onValueChange(d)"
         [readonly]="false"
         #datepickerInput
         #d="bsDatepicker">

  <!-- Clear button -->
  <button type="button"
          class="btn btn-outline-secondary rmv-btn  border-start-0 d-flex align-items-center"
          [disabled]="d.isDisabled"
          (click)="clear(d)">
    <img src="design/images/close-dark.png" class="dark" width="12" height="12" alt="remove">
    <img src="design/images/close-light.png" class="light" width="12" height="12" alt="remove">
  </button>

  <!-- Calendar toggle button -->
  <button type="button"
          class="btn btn-outline-secondary px-2 border-start-0 d-flex align-items-center"
          (click)="d.toggle()"
          [attr.aria-expanded]="d.isOpen">
    <img src="design/images/calendar.png" width="16" height="16" alt="calendar">
  </button>
</div>

    <!-- Display error message for invalid month -->
    <div *ngIf="errorMessage" class="text-danger" style="font-size:.875em">
      {{ errorMessage }}
    </div>
  `,
})
export class DatepickerTypeComponent extends FieldType {

  @ViewChild('datepickerInput', { static: false }) datepickerInput: ElementRef<HTMLInputElement>;
  constructor(public common:CommonService) {
    super();
   }
  bsConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD-MMM-YY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    customTodayClass: 'custom-today-class',
    adaptivePosition: true
  };

  errorMessage = '';
  clear(d) {
    d.bsValue = null;
    this.errorMessage = '';
  }

  onValueChange(dp: BsDatepickerDirective) {
    if (dp && dp._bsValue) {
      this.errorMessage = ''; // Clear any existing error message if month is valid
      if (this.datepickerInput == null) {
        return;
      }
      else{
        const rawInputText = this.datepickerInput.nativeElement.value;
        if(rawInputText.length>0 && this.common.omitSpecialChar(rawInputText)){
          this.errorMessage = "Special character other than - is not allowed"; 
          return false;
        }
        const dateArray = rawInputText.split('-');
        if (dateArray.length != 3) {
          return false;
        }
        else{
          const day = dateArray[0];
          const month = dateArray[1];
          const year = dateArray[2];
          var fullYear=parseInt(dp._bsValue.toString().split(" ")[3]);
          fullYear = year.length == 4 ? parseInt(year) : fullYear;
          if (!Number.isNaN(parseInt(month)) && parseInt(month) >= 1 && parseInt(month) <= 12) {
            dp._bsValue.setMonth(parseInt(month) - 1);
          }
          else if (parseInt(month) > 12) {
            dp._bsValue.setMonth(11);
            this.errorMessage = "Month should be between 1 and 12."; // Set the error message for invalid month
          }
          if (year.length > 2) {
            dp._bsValue.setFullYear(parseInt(year))
            if(parseInt(year) < 1900 || parseInt(year) > 2100 ){
              this.errorMessage="Please enter a valid date."
            }
            if(this.isLeapYear(year) &&  parseInt(month)===2 &&  parseInt(day)===29){
              dp._bsValue.setMonth(1);
              dp._bsValue.setDate(29);
            }
          }
          if (([1, 3, 5, 7, 8, 10, 12].includes(parseInt(month)) && parseInt(day) > 31) || ([4, 6, 9, 11].includes(parseInt(month)) && parseInt(day) > 30)
            || (parseInt(month) == 2 && !this.isLeapYear(fullYear) && parseInt(day) > 28) || (parseInt(month) == 2 && this.isLeapYear(fullYear) && parseInt(day) > 29))
            this.errorMessage="Please enter a valid calender date."
          dp._bsValue.setHours(0);
          dp._bsValue.setMinutes(0);
          dp._bsValue.setSeconds(0);
          dp._bsValue.setMilliseconds(0);
        }
      }
      //   const convertedDate = getDateAsUTC(dp._bsValue);
      //   dp._bsValue.setTime(convertedDate.getTime());
    }
  }
  isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }
}
